import { type OpenApiGetAllProductsCountsResponseSuccess } from '#shared/api/schema';

export const getProductYmlGoodsModerationPendingCount = (counts: OpenApiGetAllProductsCountsResponseSuccess): number =>
    counts.yml_goods_moderation_blocked_count + counts.yml_goods_moderation_in_progress_count;

export const getProductYmlGoodsModerationFilterCounts = (
    counts: OpenApiGetAllProductsCountsResponseSuccess
): Record<'ALL' | 'IN_PROGRESS' | 'BLOCKED', number> => {
    return {
        ALL: getProductYmlGoodsModerationPendingCount(counts),
        IN_PROGRESS: counts.yml_goods_moderation_in_progress_count,
        BLOCKED: counts.yml_goods_moderation_blocked_count,
    };
};
